import { ref } from "vue";
export const routeNavPending = ref(false);
let stopTimer = null;
let startedAt = 0;
const MIN_VISIBLE_MS = 200;
export function startRouteLoading() {
    if (stopTimer) {
        clearTimeout(stopTimer);
        stopTimer = null;
    }
    routeNavPending.value = true;
    startedAt = Date.now();
}
export function stopRouteLoading() {
    const elapsed = Date.now() - startedAt;
    const wait = Math.max(0, MIN_VISIBLE_MS - elapsed);
    stopTimer = setTimeout(() => {
        routeNavPending.value = false;
        stopTimer = null;
    }, wait);
}
